import React, { useEffect, useState } from "react";
import { useGetAssignmentByVideoIdQuery } from "../features/assignment/assignmentApi";

const useIsAssignmentExists = ({ video }) => {
  const [isAssignmentExist, setIsAssignmentExist] = useState(false);
  const [check, setCheck] = useState(false);

  const {
    data: assignment,
    isLoading: assignmentReqLoading,
    isSuccess,
    refetch,
  } = useGetAssignmentByVideoIdQuery(video?.id, {
    skip: !check,
  });

  useEffect(() => {
    if (video?.id) {
      setCheck(true);
    }
  }, [video?.id]);

  useEffect(() => {
    if (isSuccess && assignment?.length > 0) {
      refetch();
      setIsAssignmentExist(true);
    } else {
      setIsAssignmentExist(false);
    }
  }, [assignment, isSuccess]);

  return { isAssignmentExist, assignment };
};

export default useIsAssignmentExists;
